import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Resets the scroll position to the top on route changes.
 *
 * BrowserRouter (react-router v7) does not restore/reset scroll on its own.
 * Hash navigation (e.g. `/fr/#services`) is intentionally skipped because the
 * target page scrolls to the matching section itself, so we only reset when
 * landing on a new path without a hash.
 */
const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) return;
    // `behavior: "instant"` forces a non-animated jump regardless of the global
    // `html { scroll-behavior: smooth }`, so the new page appears at the top
    // immediately instead of smooth-scrolling up from the previous position.
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
